"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const spinner_1 = require("@pulse-web-ui/spinner");
const theme_1 = require("@pulse-web-ui/theme");
const react_1 = __importDefault(require("react"));
const button_styles_1 = require("./button.styles");
const noop = () => { };
const Button = (_a) => {
    var { label, children, onClick, icon, postIcon, disabled, isLoading, variant = 'primary' } = _a, rest = __rest(_a, ["label", "children", "onClick", "icon", "postIcon", "disabled", "isLoading", "variant"]);
    const theme = (0, theme_1.useTheme)();
    const squareGap = variant === 'square' || variant === 'square-secondary' ? 0 : 8;
    const contentGap = postIcon ? 4 : squareGap;
    return (react_1.default.createElement(button_styles_1.StyledBtn, Object.assign({ onClick: !disabled && !isLoading ? onClick : noop, variant: variant, disabled: disabled, isLoading: isLoading }, rest),
        react_1.default.createElement(button_styles_1.StyledBtnWrapper, null,
            isLoading && !disabled && (react_1.default.createElement(spinner_1.Spinner, { color: theme.colors['on-accent'].primary })),
            react_1.default.createElement(button_styles_1.StyledBtnContent, { isLoading: isLoading && !disabled, gap: contentGap },
                icon ? react_1.default.createElement(button_styles_1.StyledIcon, null, icon) : null,
                react_1.default.createElement(button_styles_1.StyledBtnLabel, { variant: variant },
                    label || children || null,
                    postIcon ? react_1.default.createElement(button_styles_1.StyledIcon, null, postIcon) : null)))));
};
exports.Button = Button;
